import React from 'react';
import { Lot } from '../types/lot/lot';

export interface LotContextProps {
  lots: Map<string, Lot>;
  setLots: (lots: Map<string, Lot>) => void;
  lotsLoading: boolean;
}

const defaultContext: LotContextProps = {
  lots: new Map(),
  setLots: () => {},
  lotsLoading: false,
};

export const LotContext = React.createContext<LotContextProps>(defaultContext);
